import { getBrand } from '@gbi/ui';
import config from '../../config';

/**
 * The active brand's design tokens, from the shared @gbi/ui package.
 *
 * Mirrors how `themeColors` works today — resolved once at module load from
 * `REACT_APP_BROKER` — so adopting it is a swap, not a restructure. `getBrand` accepts
 * the broker names this app uses ('HardAssetsAlliance', 'GoldSilver') directly.
 *
 * Use this instead of `themeColors` in new code. The two can coexist while screens migrate,
 * but they are not the same values: the tokens follow the design library, so a few
 * colours differ slightly from the old theme. Move a whole screen at a time.
 */
const tokens = getBrand(config.brokerTheme);

export default tokens;
